// extracted by mini-css-extract-plugin
export default {"colorStop":"I_qeR7Zc0G","handle":"AwgzksijyO","handleColor":"EZyzSuV5Mh"};